import React from 'react';

function LoadingSpinner() {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Cargando, por favor espera...</p>
    </div>
  );
}

export default LoadingSpinner;
